class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      // If on cart page, don't open drawer - just stay on cart page
      if (this.isOnCartPage()) {
        return;
      }
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        // If on cart page, don't open drawer - just stay on cart page
        if (this.isOnCartPage()) {
          return;
        }
        this.open(cartLink);
      }
    });
  }

  isOnCartPage() {
    return window.location.pathname === '/cart' || window.location.pathname === '/cart/';
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    this.hideThirdPartyWidgets();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.showThirdPartyWidgets();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // If on cart page, refresh the page instead of opening the drawer
    if (this.isOnCartPage()) {
      window.location.reload();
      return;
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  hideThirdPartyWidgets() {
    // Hide Shopify Inbox chat widget
    const shopifyChat = document.querySelector('#shopify-chat, .shopify-chat, iframe[src*="shopify-chat"], [id*="ShopifyChat"]');
    if (shopifyChat) {
      shopifyChat.style.display = 'none';
    }

    // Hide Klaviyo teaser (class starts with "kl-teaser-")
    const klaviyoTeaser = document.querySelector('div[class*="kl-teaser"], div[data-testid="animated-teaser"]');
    if (klaviyoTeaser) {
      // Find the outermost fixed-position parent
      let target = klaviyoTeaser;
      while (target.parentElement && getComputedStyle(target.parentElement).position === 'fixed') {
        target = target.parentElement;
      }
      target.dataset.cartDrawerHidden = 'true';
      target.style.display = 'none';
    }
  }

  showThirdPartyWidgets() {
    // Show Shopify Inbox chat widget
    const shopifyChat = document.querySelector('#shopify-chat, .shopify-chat, iframe[src*="shopify-chat"], [id*="ShopifyChat"]');
    if (shopifyChat) {
      shopifyChat.style.display = '';
    }

    // Restore any elements we hid (Klaviyo teaser, etc.)
    document.querySelectorAll('[data-cart-drawer-hidden="true"]').forEach((el) => {
      el.style.display = '';
      delete el.dataset.cartDrawerHidden;
    });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
